import { render, staticRenderFns } from "./StringFormatter.WordCount.vue?vue&type=template&id=4ff6f579&scoped=true"
import script from "./StringFormatter.WordCount.vue?vue&type=script&lang=js"
export * from "./StringFormatter.WordCount.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.WordCount.vue?vue&type=style&index=0&id=4ff6f579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff6f579",
  null
  
)

export default component.exports